module.exports = __webpack_public_path__ + "static/assets/8b0139a3ddaa6df7a298401cab967970.svg";